import { Design } from '../../../types';

export enum DesignTtsType {
  ttsOnly = 'ttsOnly',
  ttsAndVoice = 'ttsAndVoice',
  voiceOnly = 'voiceOnly'
}

export function getDesignTtsType(serialized: Design): DesignTtsType {
  const { languages } = serialized;
  if (languages.every(({ voice }) => !voice)) {
    return DesignTtsType.ttsOnly;
  } else if (languages.every(({ ttsFallBackVoice }) => !ttsFallBackVoice)) {
    return DesignTtsType.voiceOnly;
  }
  return DesignTtsType.ttsAndVoice;
}
